import { useEffect } from 'react';
import { useDomainEnv, useEnv } from 'src/hooks';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { isProdEnv } = useEnv();
  const { isDomainProdEnv } = useDomainEnv();

  useEffect(() => {
    document.documentElement.setAttribute(
      'data-theme',
      isProdEnv ? 'prod' : 'demo',
    );

    if (!isDomainProdEnv) {
      const savedBrand = localStorage.getItem('brand') || 'oyindonesia';
      document.documentElement.setAttribute('data-brand', savedBrand);
      window.__setBrand = (b: string) => {
        document.documentElement.setAttribute('data-brand', b);
        localStorage.setItem('brand', b);
      };
    } else {
      document.documentElement.removeAttribute('data-brand');
      if (window.__setBrand) {
        delete window.__setBrand;
      }
    }
  }, [isProdEnv, isDomainProdEnv]);
  return <>{children}</>;
}
